export class BackOrder {      
  id: number;
  order_number: string;
  invoice_number: string;
  client: string;
  salesman: string;
  order_date: string;// = (new Date()).toISOString().substr(0,10);
  delivery_date: string;// = (new Date()).toISOString().substr(0,10);
  qty: number;
  type: string;
  branch: string;
  branch_id: number;
  requesting_branch_id: number;
  //Default to "Draft" status on create
  status: string = 'DRAFT';
  customer_prefix: string;
  customer_name: string;
  customer_id: number;
  notes: string;
  shipping_charges: number = 0;
  discount: number = 0;

  tax: number = 0;

  items: any[] = [];

  prepared_location_id: number;

  //links the B2B PO with the Sales Order
  po_id: string; 
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/sales/backorder.ts